<template>
  <div id="map"></div>
</template>
<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import * as olProj from 'ol/proj'
import ScaleLine from 'ol/control/ScaleLine'
import { defaults } from 'ol/interaction'
import Feature from 'ol/Feature'
import { Vector as VectorLayer } from 'ol/layer'
import { getVectorContext } from 'ol/render'
import LineString from 'ol/geom/LineString'
import * as turf from '@turf/turf'
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style
} from 'ol/style'
let lastTime
var geoMarker
var routeFeature
var styles
const distance = 0
var position
var data
export default {
  props: {
    lon: {
      type: [String, Number],
      default: 113.68311000000000
    },
    lat: {
      type: [String, Number],
      default: 25.55434000000000
    }
  },
  data () {
    return {
      data: [0, 0]
    }
  },
  created () { },
  mounted () {
    this.initMap(this.lon, this.lat)
  },
  methods: {
    initMap (lon, lat) {
      if (this.lon == '' || this.lon == null) {
        lon = 113.68311000000000
      }
      if (this.lat == '' || this.lat == null) {
        lat = 25.55434000000000
      }
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      this.map = new Map({
        view: new View({
          center: [lon, lat], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 14, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        target: 'map' // 地图容器id
      })
      const scaleLineControl = new ScaleLine({
        // 设置度量单位为米
        units: 'metric',
        target: 'scalebar',
        className: 'ol-scale-line'
      })
      this.map.addControl(scaleLineControl)
      const roadLayer = new TileLayer({
        name: '底图',
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      this.map.addLayer(roadLayer)
      this.createIcon()
    },
    createIcon () {
      this.endMarker = new Feature({
        type: 'endicon',
        geometry: new Point(this.data)
      })
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [this.endMarker]
        }),
        style: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: require('@/assets/myImg/1/ixy.png')
          })
        })
      })
      this.map.addLayer(this.vectorLayer)
      var that = this
      this.map.on('singleclick', event => {
        that.data = event.coordinate
        that.endMarker.getGeometry().setCoordinates(that.data)
        this.$emit('mapHandle', that.data)
      })
    }
  }
}
</script>

<style lang="less" scoped>
#map {
  width: 500px;
  height: 300px
}
</style>
